import { createContext } from 'react';
import { currentDocument } from '../../utils/env';

export type HostableSurfaceEvents = 'surfaceClick' | 'surfaceResize';
const noopFunction = () => { /* NOOP */ };
export type Handler = (...args: any[]) => void;

export interface IHostableSurfaceContextProps {
    surfaceElement: HTMLElement;
    getSurfaceClientRect(): ClientRect;
    addSurfaceEventListener(eventName: HostableSurfaceEvents, handler: Handler): void;
    removeSurfaceEventListener(eventName: HostableSurfaceEvents, handler: Handler): void;
}

export const HostableSurfaceContext = createContext<IHostableSurfaceContextProps>({
    getSurfaceClientRect() {
        return currentDocument.body.getBoundingClientRect();
    },
    addSurfaceEventListener: noopFunction,
    removeSurfaceEventListener: noopFunction
} as any);

export const HostableSurfaceProvider = HostableSurfaceContext.Provider;
export const HostableSurfaceConsumer = HostableSurfaceContext.Consumer;
